
import React, { createContext, useContext } from 'react';
import { SearchContextType } from './SearchTypes';
import { useSearchResults } from '../hooks/useSearchResults';

const SearchContext = createContext<SearchContextType | null>(null);

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
};

export const SearchProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const searchResults = useSearchResults();
  
  return (
    <SearchContext.Provider value={searchResults}>
      {children}
    </SearchContext.Provider>
  );
};
